import { useEffect } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";

interface CheckboxFilterProps {
    title: string;
    items: string[];
    selectedItems: string[];
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;
    openDropdown: string | null;
    setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
    filterName: string;
}

export const CheckboxFilter: React.FC<CheckboxFilterProps> = ({ title, items, selectedItems, setSelectedItems, openDropdown, setOpenDropdown, filterName }) => {
    const isOpen = openDropdown === filterName;

    const toggleItem = (item: string) => {
        setSelectedItems((prev) => (prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]));
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const dropdown = document.getElementById(`checkbox-filter-${filterName}`);
            if (dropdown && !dropdown.contains(event.target as Node)) {
                setOpenDropdown(null);
            }
        };

        if (isOpen) {
            window.addEventListener("click", handleClickOutside);
        }

        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, [isOpen, filterName, setOpenDropdown]);

    return (
        <div className="relative" id={`checkbox-filter-${filterName}`}>
            <div
                className="border border-solid px-2 py-3 md:py-1 border-gray-200 bg-gray-50 cursor-pointer flex items-center justify-between md:w-fit w-full rounded-md"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdown(isOpen ? null : filterName);
                }}
            >
                <span>
                    {selectedItems.length ? (
                        `${title} (${selectedItems.length})`
                    ) : (
                        <span className="flex items-center">
                            {filterName}
                            <IoMdArrowDropdown />
                        </span>
                    )}
                </span>
                {selectedItems.length > 0 && (
                    <RxCross1
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedItems([]);
                            setOpenDropdown(null);
                        }}
                        className="ml-2"
                    />
                )}
            </div>

            {isOpen && (
                <div className="absolute z-50 mt-0 bg-white border shadow md:w-96 max-h-64 overflow-y-auto w-full">
                    {items.map((item) => (
                        <label key={item} className="flex items-center px-3 py-1 hover:bg-gray-100 cursor-pointer">
                            <input type="checkbox" checked={selectedItems.includes(item)} onChange={() => toggleItem(item)} className="mr-2" />
                            {item}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
